import { Directive, ElementRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appBlurFade]',
  standalone: true
})
export class BlurFadeDirective implements OnInit, OnDestroy {
  @Input() blurFadeDelay = 0;

  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const element = this.el.nativeElement as HTMLElement;
    element.style.setProperty('--blur-fade-delay', `${this.blurFadeDelay}s`);
    element.classList.add('blur-fade');

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          element.classList.add('blur-fade--visible');
          this.observer?.unobserve(element);
        }
      });
    }, { threshold: 0.1, rootMargin: '-30px 0px' });

    this.observer.observe(element);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}